<template>
<div style="width: 85%; margin: auto; padding-top: 10px; color: #7b7c87">
    <v-layout row wrap>
      <v-flex
        xs12
        md12
        lg12
        xl12
        style="padding: 15px; padding-bottom: 2px !important"
      >
        <!--Row #1-->
        <v-layout row wrap>
          <v-flex
            xs12
            sm12
            md10
            lg10
            xl10
            style="padding: 15px; padding-bottom: 0px"
          >
            <div
              style="padding-top: 23px; font-weight: bolder; font-size: 20px"
            >
              مدیریت باکس های تصویری فروشگاه
            </div>
          </v-flex>
        </v-layout>
      </v-flex>
      <v-flex xs12 sm12 md12 lg12 xl12 style="padding:20px">
          <v-card>
              <v-card-text>
                  <v-data-table :items="BoxTableItems" :headers="BoxTableHeaders">
                      <template v-slot:[`item.type`]="{item}">
                          <v-chip v-if="item.type == 2 || item.type == 1" color="blue" dark>لینک</v-chip>
                          <!-- <v-chip v-else-if="item.type == 1" color="orange" dark>محصول</v-chip>
                          <v-chip v-else-if="item.type == null" color="red darken-4" dark>تعریف نشده</v-chip> -->
                      </template>
                      <template v-slot:[`item.link`]="{item}">
                          <v-icon small v-if="item.type == 2 || item.type == 1" @click="window.open(`${item.link}`)" color="blue" dark>fa fa-eye</v-icon>
                          <!-- <span v-else-if="item.type == 1"  light>---</span> -->
                          <span v-else-if="item.type == null"  light>تعریف نشده</span>
                      </template>
                      <template v-slot:[`item.operation`]="{item}">
                          <v-btn color="yellow darken-4" icon @click="SetBoxDetail(item)"><v-icon small>fa fa-cog</v-icon></v-btn>&nbsp;
                          <!-- <v-tooltip v-if="item.type == 1" top color="purple darken-4">
                            <template v-slot:activator="{ on, attrs }">
                                <v-btn
                                text
                                icon
                                v-bind="attrs"
                                v-on="on"
                                small
                                color="purple darken-4"
                                @click="ShowBoxProducts(item.sectionId,item.id)"
                                ><v-icon small>fas fa-compress-arrows-alt</v-icon></v-btn
                                >
                            </template>
                            <span>لیست محصولات</span>
                          </v-tooltip> -->
                      </template>
                  </v-data-table>
              </v-card-text>
          </v-card>
      </v-flex>
      <template>
          <v-dialog persistent max-width="600px" v-model="SetBoxDetailDialog">
              <v-card>
                <v-card-title style="padding: 0px !important">
                    <v-app-bar dense color="rgb(42, 45, 69)" dark>
                    <v-toolbar-title style="color: orange">
                        <span>تنظیمات باکس</span>
                    </v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-icon color="orange" @click="SetBoxDetailDialog = false" small
                        >fa fa-times</v-icon
                    >
                    </v-app-bar>
                </v-card-title>
                <v-card-text>
                    <v-layout row wrap>
                        <v-flex xs12 sm12 md12 lg12 xl12 style="padding:20px">
                            <v-row>
                                <v-col cols="8"><span>نوع </span> :</v-col>
                                <v-col cols="4" style="display: flex; justify-content: flex-end">
                                    <v-btn-toggle v-model="boxType" mandatory>
                                      <v-btn class="ml-1" color="blue" dark small >لینک</v-btn>
                                      <v-btn color="orange" dark small :value="false">لیست محصولات</v-btn>
                                    </v-btn-toggle>
                                </v-col>
                            </v-row>
                            <v-text-field
                            color="#2a2d45"
                            v-model="boxTitle"
                            outlined
                            dense
                            label="عنوان باکس "
                            ></v-text-field>
                            <v-text-field
                            color="#2a2d45"
                            v-model="boxSubTitle"
                            outlined
                            dense
                            label="زیر عنوان باکس "
                            ></v-text-field>
                            <v-text-field
                            color="#2a2d45"
                            v-model="boxLink"
                            outlined
                            dense
                            label="لینک "
                            ></v-text-field>
                            <f-up  :OldFile="boxImage" @RetunedFileName="boxImage = $event" Root="ELOGO" Folder="NONE" BtnTitle="عکس"></f-up>
 
                             <v-btn @click="SaveBoxDetail" outlined dark color="blue">
                              <v-icon small style="padding-left: 5px"
                                >fa fa-check</v-icon
                              >&nbsp; ذخیره
                            </v-btn>
                        </v-flex>
                        <!-- <v-flex xs12 sm12 md8 lg8 xl8 style="padding:20px">
                            <seo-form FileLoc="PRDCATSEOIMG" :Seo="SeoData" @SeoData="SeoChanged" v-if="!boxType"></seo-form>
                        </v-flex> -->
                    </v-layout>
                </v-card-text>
              </v-card>
          </v-dialog>
      </template>
      <template>
        <v-dialog fullscreen persistent v-model="SetBoxProductsDialog">
         <v-card>
         <v-card-title style="padding: 0px !important">
            <v-app-bar dense color="rgb(42, 45, 69)" dark>
              <v-toolbar-title style="color: orange">
                <span>محصولات باکس</span>
              </v-toolbar-title>
              <v-spacer></v-spacer>
              <v-icon color="orange" @click="closeDialog" small
                >fa fa-times</v-icon
              >
            </v-app-bar>
          </v-card-title>
          <v-card-text>
            <v-layout row wrap>
              <v-flex xs12 sm12 md12 lg12 xl12 style="padding:20px">
                <div class="operationBoxDesign">
                <div
                  class="OperationBoxColumns"
                  v-for="i in MAXCATLEVELCOUNT"
                  :key="'catselectionholder' + i"
                >
                  <v-autocomplete
                    no-data-text="دسته بندی یافت نشد"
                    color="#2a2d45"
                    item-text="pC_Title"
                    item-value="pC_Id"
                    :items="FooterCategoryItems['cat' + i]"
                    @change="FooterCatSelectionChanged(i + 1, $event)"
                    :label="'دسته بندی سطح ' + i"
                    outlined
                    dense
                    v-model="FooterCategoryModel['cat' + i]"
                  ></v-autocomplete>
                </div>
              </div>
              </v-flex>
              <v-flex xs12 sm12 md4 lg4 xl4 style="padding:20px">
                <v-text-field outlined v-model="SetProductsSearchByPName" dense label="نام محصول"></v-text-field>
              </v-flex>
              <v-flex xs12 sm12 md4 lg4 xl4 style="padding:20px">
                <v-text-field outlined dense v-model="SetProductsSearchByPCode" label="کد محصول"></v-text-field>
              </v-flex>
              <v-flex xs12 sm12 md4 lg4 xl4 style="padding:20px">
                <v-btn @click="loadProductsForSet(1)" outlined block color="rgb(42, 45, 69)"><v-icon small style="padding-left:5px">fa fa-search</v-icon>جستجو</v-btn>
              </v-flex>
              <v-flex xs12 sm12 md12 lg12 xl12 style="padding:20px">
                <div class="d-flex justify-center align-center cpation font-weight-black">همه محصولات</div>
              </v-flex>
              <v-flex xs12 sm12 md12 lg12 xl12 style="padding:20px">
                <v-data-table :items-per-page="PageSizeSet" :items="SetAllProductTableItems" hide-default-footer :headers="MainTableHeader">
                  <template v-slot:[`item.operation`]="{item}">
                    <v-btn x-small @click="ShiftToSetTabl(item)" color="green accent-4"><v-icon color="#fff" x-small>fa fa-plus</v-icon></v-btn>
                  </template>
                </v-data-table>
                <v-row>
                  <v-col cols="10"><v-pagination @input="SetProdTableJumpToPage($event)" v-model="CurrentPageSet" color="orange" :length="PageCountsSet" total-visible></v-pagination></v-col>
                  <v-col cols="2"><v-select @change="loadProductsForSet(1)" label="تعداد آیتم در صفحه" :items="PageSizeItems" item-text="text" item-value="value" outlined dense v-model="PageSizeSet"></v-select></v-col>
                </v-row>
              </v-flex>
              <v-flex xs12 sm12 md12 lg12 xl12 style="padding:20px" class="flex-row d-flex justify-sm-space-between">
                <div class="d-flex justify-center align-center cpation font-weight-black">محصولات زیر مجموعه</div>
                <v-btn outlined color="green" @click="SaveProductSet()"><v-icon small style="padding-left:5px">fa fa-check</v-icon>بروزرسانی</v-btn>
              </v-flex>
              <v-flex xs12 sm12 md12 lg12 xl12 style="padding:20px">
                <v-data-table :items="SetTableItems" :headers="RelationTableHeader">
                  <template v-slot:[`item.operation`]="{item}">
                    <v-btn x-small @click="DeleteFromSetTable(item)" color="red accent-4"><v-icon color="#fff" x-small>fa fa-trash</v-icon></v-btn>
                  </template>
                  <template v-slot:[`item.discount`]="{item}">
                    <v-row>
                      <v-col cols="2"><v-btn @mouseleave="stop" @mouseup="stop" @touchend="stop" @touchcancel="stop" @mousedown="start(item)" @touchstart="start(item)" small icon><v-icon small>fa fa-plus</v-icon></v-btn></v-col>
                      <v-col cols="8">
                        <v-text-field flat full-width style="text-align:center;justify-content:center" v-model="item.discount" outlined dense></v-text-field>
                      </v-col>
                      <v-col cols="2"><v-btn @click="(item.discount > 0)? item.discount--:item.discount = 0" small icon><v-icon small>fa fa-minus</v-icon></v-btn></v-col>
                    </v-row>
                  </template>
                  <template v-slot:[`item.discountype`]="{item}">
                      <v-row>
                          <v-col cols="4" style="display: flex;justify-content: flex-end;">
                              <v-switch :label="(item.discountype) ? 'ریال':'درصد'" v-model="item.discountype" style="padding-top:0px !important;margin-top:0px !important" color="#2a2d45"></v-switch>
                          </v-col>
                     </v-row>

                  </template>
                </v-data-table>
              </v-flex>
            </v-layout>
            
          </v-card-text>
        </v-card>

        </v-dialog>
        <template>
      <!--Loading Dialog-->
      <div class="vld-parent">
        <loading
          color="#f75314"
          :width="parseInt(45)"
          :height="parseInt(45)"
          background-color="#fff"
          :active.sync="isLoading"
          :is-full-page="true"
        ></loading>
      </div>
    </template>
      </template>
    </v-layout>
</div>

</template>
<script>
const axios = require("axios");
const ApiUrl = require("../../constant/apiurl");
const MSGHNDL = require("../../constant/MessageHandler");
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import JsonExcel from "vue-json-excel";

export default {
    name:"ImageBox",
    components: {
    Loading,
    JsonExcel,
  },
    data:()=>({
      BoxID:0,
    SetProductDialog:false,
    SetProductsSearchByPName:"",
    SetProductsSearchByPCode:"",
    SetAllProductTableItems:[],
    SetTableItems:[],
    CurrentPageSet : 0,
    PageCountsSet: 0 ,
    PageSizeSet: 5,
    PageSizeItems:[
      {text:"5",value:5},
      {text:"10",value:10},
      {text:"20",value:20},
      {text:"40",value:40},
      {text:"100",value:100},
      {text:"200",value:200},
      {text:"500",value:500},
      {text:"5000",value:5000}
    ],
    RelationTableHeader: [
      { text: "#", value: "counter", sortable: true, align: "right" },
      { text: "کد", value: "code", sortable: true, align: "right" },
      { text: "محصول ", value: "title", sortable: true, align: "right" },
      { text: "گارانتی ", value: "warranty", sortable: true, align: "right" },
      { text: "رنگ ", value: "color", sortable: true, align: "right" },
      { text: "قیمت ", value: "price", sortable: true, align: "right" },
      { text: "تخفیف ", value: "discount", sortable: true, align: "right" },
      { text: "نوع تخفیف ", value: "discountype", sortable: true, align: "right" },
      { text: "عملیات ", value: "operation", sortable: true, align: "right" },
    ],
    MainTableHeader: [
      { text: "#", value: "counter", sortable: true, align: "right" },
      { text: "کد", value: "code", sortable: true, align: "right" },
      { text: "محصول ", value: "title", sortable: true, align: "right" },
      { text: "گارانتی ", value: "warranty", sortable: true, align: "right" },
      { text: "رنگ ", value: "color", sortable: true, align: "right" },
      { text: "قیمت ", value: "price", sortable: true, align: "right" },
      { text: "تخفیف ", value: "discount", sortable: true, align: "right" },
      { text: "عملیات ", value: "operation", sortable: true, align: "right" },
    ],
    BoxTableHeaders:[
        { text: "#", value: "counter", sortable: true, align: "right" },
        { text: "عنوان باکس", value: "title", sortable: true, align: "right" },
        { text: "نوع باکس", value: "type", sortable: true, align: "right" },
        { text: "لینک", value: "link", sortable: true, align: "right" },
        { text: "عملیات", value: "operation", sortable: true, align: "right" },
    ],
    BoxTableItems:[
        {counter:1,title:"باکس 1",boxSubTitle:"زیر عنوان",type:null,link:"",image:"",imagemobile:"",seo:"",sectionId:1,id:0},
        {counter:2,title:"باکس 2",boxSubTitle:"زیر عنوان",type:null,link:"",image:"",imagemobile:"",seo:"",sectionId:2,id:0},
        {counter:3,title:"باکس 3",boxSubTitle:"زیر عنوان",type:null,link:"",image:"",imagemobile:"",seo:"",sectionId:3,id:0},
        {counter:4,title:"باکس 4",boxSubTitle:"زیر عنوان",type:null,link:"",image:"",imagemobile:"",seo:"",sectionId:4,id:0},
        {counter:5,title:"باکس 5",boxSubTitle:"زیر عنوان",type:null,link:"",image:"",imagemobile:"",seo:"",sectionId:5,id:0}
      

    ],
    SetBoxDetailDialog:false,
    boxId:"",
    boxTitle:"",
    boxSubTitle:"",
    boxType:false,
    boxLink:"",
    boxImage:"",
    boxImageMobile:"",
    uploadBoxImage:"",
    SeoData:{},
    seo:{},
    SetBoxProductsDialog:false,
    SetProductBoxId:0,
    SetProductsSearchByPName:"",
    SetProductsSearchByPCode:"",
    SetAllProductTableItems:[],
    interval:false,
    SelectedItem:{},
    isLoading:false,
      MAXCATLEVELCOUNT:0,
        FooterCategoryItems: {
      cat1: [],
      cat2: [],
      cat3: [],
      cat4: [],
      cat5: [],
      cat6: [],
      cat7: [],
      cat8: [],
      cat9: [],
      cat10: [],
      cat11: [],
      cat12: [],
      cat13: [],
      cat14: [],
      cat15: [],
      cat16: [],
      cat17: [],
      cat18: [],
      cat19: [],
      cat20: [],
    },
    CategoryItems: {
      cat1: [],
      cat2: [],
      cat3: [],
      cat4: [],
      cat5: [],
      cat6: [],
      cat7: [],
      cat8: [],
      cat9: [],
      cat10: [],
      cat11: [],
      cat12: [],
      cat13: [],
      cat14: [],
      cat15: [],
      cat16: [],
      cat17: [],
      cat18: [],
      cat19: [],
      cat20: [],
    },
FooterCategoryModel: [],
    CatId:0
    }),
    async created(){
      let vm = this;
      await this.getAllowedMaxLevelCount();
        this.uploadBoxImage = ApiUrl.registerPcImg;
        await this.LoadBoxs();
        
        await this.loadProductsForSet();
        
        axios.interceptors.request.use(
      (config) => {
        vm.isLoading = true;
        return config;
      },
      (error) => {
        vm.isLoading = false;
        return Promise.reject(error);
      }
    );

    axios.interceptors.response.use(
      (response) => {
        vm.isLoading = false;
        return response;
      },
      (error) => {
        vm.isLoading = false;
        return Promise.reject(error);
      }
    );
    },
    methods:{
      closeDialog()
      {
        let vm = this;
        vm.SetBoxProductsDialog = false;
        vm.SetTableItems = [];
        while(vm.SetTableItems.length > 0) {
            vm.SetTableItems.pop();
        }
      },
      async FooterCatSelectionChanged(lvl, val) {
      let vm = this;
      if (lvl <= vm.MAXCATLEVELCOUNT) {
        let Model = {};
        Model.Id = val;
        let index = "cat" + lvl;
        await axios
          .post(ApiUrl.getCategoryChilds, Model)
          .then(async (res) => {
            let data = res.data;
            if (data.status) {
              vm.$data["FooterCategoryItems"][index] = data.data.childs;
              console.warn("data:", data.data.childs);
            }
          })
          .catch((err) => {
            console.error(err);
          });
      } else {
        vm.CatId = val;
        await vm.loadProductsForSet();
      }
    },
      async getAllowedMaxLevelCount() {
      let vm = this;

      await axios
        .post(ApiUrl.getCategoiesOfLevelOne)
        .then(async (res) => {
          let data = res.data;
          if (data.status) {
            vm.MAXCATLEVELCOUNT = data.data.max;
            for (let i = 1; i <= vm.MAXCATLEVELCOUNT; i++) {
              let index = `cat${i}`;
              vm.CategoryItems[index] = [];
              vm.FooterCategoryItems[index] = [];
            }
            vm.CategoryItems["cat1"] = data.data.cats;
            vm.FooterCategoryItems["cat1"] = data.data.cats;
          }
        })
        .catch((err) => {
          console.error(err);
        });
    },
     async SaveProductSet() {
      let vm = this;
        let ArrObject = [];
        // alert(vm.BoxID);
        
        vm.SetTableItems.forEach((e) => {
          var Model = {};
          Model.X_SectionId = vm.SetProductBoxId;
          Model.X_ProdId = e.id;
          Model.X_ColorId = e.cid;
          Model.X_WarrantyId = e.wid;
          Model.X_DiscountedPrice = e.discount;
          Model.X_DiscountType = e.discountype;
          Model.B_Id = vm.BoxID;
          ArrObject.push(Model);
        });
        await axios
          .post(ApiUrl.AddProductToBox+'/'+vm.SetProductBoxId, ArrObject)
          .then(async (res) => {
            let data = res.data;
            if (data.status) {
              MSGHNDL.OK(data.msg);
              await vm.loadProductsForSet();
            }
          })
          .catch((err) => {
            console.error(err);
          });
    },

    stop(){
    	clearInterval(this.interval)
      this.interval = false
    },
    start(item){
      this.SelectedItem = item;
    	if(!this.interval){
      	this.interval = setInterval(() => this.SelectedItem.discount++, 30)	
      }
    },
    ShiftToSetTabl(item)
    {
      let vm = this;
      if(vm.SetTableItems.some(x=>x.id == item.id && x.wid == item.wid && x.cid == item.cid))
      {
        MSGHNDL.ERR("تنوع مورد نظر قبلا اضافه شده است");
      }
      else
      {
        vm.SetTableItems.push(item);
      }
    },

      ShowBoxProducts(secid,bid)
      {
        let vm = this;
        vm.SetBoxProductsDialog = true;
        vm.SetProductBoxId = secid;
        vm.BoxID = bid;
        vm.loadProductsForSet();
      },
      async LoadBoxs()
      {
        let vm = this;
        await axios.post(ApiUrl.LoadPromotionBox+'/1').then((res)=>{
          var data = res.data;
          if(data.status)
          {
            for(var i in vm.BoxTableItems)
            {
              var find = data.data.findIndex(_item => _item.b_SectionId === vm.BoxTableItems[i].sectionId);
              if(find != -1)
              {
                var ritem = data.data[find];
                var litem = vm.BoxTableItems[i];
                console.info(ritem );
                litem.title = ritem.b_Title;
                litem.boxSubTitle = ritem.b_SubTitle;
                litem.type = ritem.b_LoadType ;
                litem.link = ritem.b_Link;
                litem.image = ritem.b_Image;
                litem.imagemobile = ritem.b_ImageMobile;
                litem.seo = ritem.b_Seo;
                litem.id = ritem.b_Id;
              }
            }
          }
        }).catch((err)=>{
          console.error("ERROR IN LOADING BOX INFORMATION",err);
        });
      },
      async SaveBoxDetail()
      {
        var vm = this;
        var Model = {};
        Model.B_Title = vm.boxTitle;
        Model.B_SubTitle = vm.boxSubTitle;
        Model.B_Image = vm.boxImage;
        Model.B_ImageMobile = vm.boxImageMobile;
        Model.B_Seo = JSON.stringify(vm.seo);
        Model.B_Link = vm.boxLink;
        Model.B_SectionId = vm.boxId;
        Model.B_LoadType = vm.boxType ? 2:1;
        Model.B_Type = 1;
        await axios.post(ApiUrl.AddPromotionBox,Model).then(async (res)=>{
          var data = res.data;
          if(data.status)
          {
            MSGHNDL.OK(data.msg);
            await vm.LoadBoxs();
            vm.SetBoxDetailDialog = false;
          }
          else
          {
            MSGHNDL.ERR(data.msg);
          }

        }).catch((err)=>{console.error(err)});

      },
      SeoChanged(seo)
      {
        this.seo = seo;
      },
    SetBoxDetail(secid)
    {
        this.boxId = secid.sectionId;
        if(secid.type != null)
        {
          this.boxType = secid.type == 1 ? false:true;
        }
        else
        {
          this.boxType = false;
        }
        console.warn(secid);
        this.boxTitle = secid.title;
        this.boxSubTitle = secid.boxSubTitle;
        this.boxLink = secid.link;
        this.boxImage = secid.image;
        this.boxImageMobile = secid.imagemobile;
        this.SeoData = secid.seo == "" ? {} : JSON.parse(secid.seo);
        this.SetBoxDetailDialog = true;
    }, 
    async SetProdTableJumpToPage(page)
    {
      await this.loadProductsForSet(page);
    },
    async loadProductsForSet(page = 1) {
      let vm = this;
      var url = ApiUrl.LoadProductForBoxs +"/"+vm.CatId+"/0/"+page+"/"+vm.PageSizeSet;
      if(vm.SetProductsSearchByPName != null && vm.SetProductsSearchByPName != "")
      {
        url+="/"+vm.SetProductsSearchByPName;
      }
      if(vm.SetProductsSearchByPCode != null && vm.SetProductsSearchByPCode != "")
      {
        url+="/"+vm.SetProductsSearchByPCode;
      }
      await axios
        .post(
          url
        )
        .then(async (res) => {

          let data = res.data;
          console.warn(data);
          if (data.status) {
            vm.SetAllProductTableItems = data.data.products;
            vm.PageCountsSet = data.data.totalPages;
            vm.CurrentPageSet = data.data.currentPage;
            vm.RelationDataLoaded = true;
            console.warn("LOADING RELATION DATA",data.data);
             await vm.LoadSets();
          }
        })
        .catch((err) => {
          console.error(err);
        });
    },
    async LoadSets()
    {
      let vm = this;
      var Model = {};
      Model.Id = vm.SetProductBoxId;
      await axios.post(ApiUrl.LoadPromotionBoxProds,Model)
      .then(res=>{
        let data = res.data;
        if(data.status)
        {
          console.warn("RELATIONSSSSSSSSSSSSSSSSS:",data.data);
          if(data.data.length > 0)
          {
            vm.SetTableItems = [];
            
            data.data.forEach(el => {
              var item = vm.SetAllProductTableItems.findIndex(i=>i.id == el.x_ProdId && i.wid == el.x_WarrantyId && i.cid == el.x_ColorId);
              var element = vm.SetAllProductTableItems[item];
              element.discount = el.x_DiscountedPrice;
              element.discountype = el.x_DiscountType;
              vm.SetTableItems.push(element);
            });
          }
        }
        else
        {
         MSGHNDL.ERR(data.msg);
        }
      })
      .catch(err=>{console.error(err);});
    },

    }
}
</script>